module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-solar@2x.png?2961debdd1bdd6aefcfcad7678bbd1fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-solar@2x.png
// module id = 1050
// module chunks = 1